"use strict";
exports.__esModule = true;
exports.linkBottomMenu = exports.linkMenu = exports.linkMenuHideMobileIcons = void 0;
exports.linkMenuHideMobileIcons = function (strings) {
    var results = exports.linkMenu(strings);
    delete results[1][1];
    return results;
};
exports.linkMenu = function (strings) { return [
    [
        {
            title: strings.getToKnowUs,
            links: [
                {
                    name: strings.aboutUs,
                    url: '/about/'
                },
                {
                    name: strings.careers,
                    url: '/careers/'
                },
                {
                    name: strings.blog,
                    url: 'http://blog.doordash.com'
                },
                {
                    name: strings.stories,
                    url: 'https://stories.doordash.com'
                },
                {
                    name: strings.linkedIn,
                    url: 'https://www.linkedin.com/company/doordash'
                },
                {
                    name: strings.glassdoor,
                    url: 'https://www.glassdoor.com/Reviews/DoorDash-Reviews-E813073.htm'
                },
                {
                    name: strings.accessibility,
                    url: '/accessibility/'
                },
                {
                    name: strings.deliveryLocations,
                    url: '/food-delivery/'
                },
            ]
        },
    ],
    [
        {
            title: strings.letUsHelpYou,
            links: [
                {
                    name: strings.accountDetails,
                    url: '/consumer/edit_profile/'
                },
                {
                    name: strings.orderHistory,
                    url: '/orders/'
                },
                {
                    name: strings.help,
                    url: '/help/'
                },
            ]
        },
        {
            title: strings.getTheApp,
            links: [
                {
                    name: strings.appStore,
                    url: 
                    // tslint:disable-next-line:max-line-length
                    'https://itunes.apple.com/us/app/doordash-food-delivery/id719972451?mt=8'
                },
                {
                    name: strings.googlePlay,
                    url: 'https://play.google.com/store/apps/details?id=com.dd.doordash'
                },
            ]
        },
    ],
    [
        {
            title: strings.doingBusiness,
            links: [
                {
                    name: strings.becomeADasher,
                    url: '/dasher/signup/?source=dx_signup_footer_dx_home'
                },
                {
                    name: strings.beAPartnerRestaurant,
                    url: '/merchant/apply/?internal-referrer=footer'
                },
                {
                    name: strings.getDashersForDeliveries,
                    url: '/drive/discover/'
                },
                {
                    name: strings.drivingOpportunities,
                    url: '/dasher/driving-opportunities/?source=dx_signup_page'
                },
            ]
        },
    ],
]; };
exports.linkBottomMenu = function (strings) { return [
    {
        name: strings.termsOfService,
        url: '/terms/'
    },
    {
        name: strings.privacy,
        url: '/privacy/'
    },
    {
        name: strings.deliveryLocations,
        url: '/food-delivery/'
    },
]; };
